export default __webpack_public_path__ + "static/media/Annual Secretarial Compliance Report 2025.1b97bc4c.pdf";